import { memo } from 'react';
import { Loader2, FileX, AlertCircle, RefreshCw } from 'lucide-react';
import { Button } from '../../../components/ui/button';
import { useUploadContext } from './upload-provider';

export const UploadLoadingState = memo(function UploadLoadingState() {
  return (
    <div className="flex flex-col items-center justify-center py-12">
      <Loader2 className="h-8 w-8 animate-spin text-primary mb-4" />
      <p className="text-muted-foreground">Carregando arquivos...</p>
    </div>
  );
});

export const UploadEmptyState = memo(function UploadEmptyState() {
  return (
    <div className="flex flex-col items-center justify-center py-12">
      <FileX className="h-12 w-12 text-muted-foreground mb-4" />
      <p className="text-lg font-medium text-foreground mb-2">Nenhum arquivo encontrado</p>
      <p className="text-muted-foreground text-center max-w-md">
        Nenhum arquivo foi processado hoje para este tipo de documento. Faça upload de arquivos
        para começar.
      </p>
    </div>
  );
});

interface UploadErrorStateProps {
  error: Error;
}

export const UploadErrorState = memo(function UploadErrorState({ error }: UploadErrorStateProps) {
  const { actions } = useUploadContext();

  return (
    <div className="flex flex-col items-center justify-center py-12">
      <AlertCircle className="h-12 w-12 text-destructive mb-4" />
      <p className="text-lg font-medium text-foreground mb-2">Erro ao carregar arquivos</p>
      <p className="text-muted-foreground text-center max-w-md mb-4">{error.message}</p>
      <Button variant="outline" onClick={actions.refetch}>
        <RefreshCw className="h-4 w-4 mr-2" />
        Tentar novamente
      </Button>
    </div>
  );
});

export const UploadConfigMissingState = memo(function UploadConfigMissingState() {
  return (
    <div className="p-6">
      <div className="flex flex-col items-center justify-center py-12">
        <AlertCircle className="h-12 w-12 text-destructive mb-4" />
        <h1 className="text-2xl font-bold text-destructive mb-4">
          Configuração de Upload não encontrada
        </h1>
        <p className="text-muted-foreground text-center max-w-md">
          Esta página deve ser acessada através do menu lateral. Por favor, selecione uma opção de
          upload no menu.
        </p>
      </div>
    </div>
  );
});

export const UploadRefetchingIndicator = memo(function UploadRefetchingIndicator() {
  const { state } = useUploadContext();

  if (!state.isRefetching) {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 bg-primary text-primary-foreground px-4 py-2 rounded-full shadow-lg flex items-center gap-2">
      <Loader2 className="h-4 w-4 animate-spin" />
      <span className="text-sm">Atualizando...</span>
    </div>
  );
});
